import React, { useState } from 'react';
import AppShell from '@/components/layout/AppShell';
import Dashboard from '@/views/Dashboard';
import Envelopes from '@/views/Envelopes';
import Transactions from '@/views/Transactions';
import Settings from '@/views/Settings';
import Demo from '@/views/Demo';
import '@questlabs/react-sdk/dist/style.css';

export default function App() {
  const [currentTab, setCurrentTab] = useState('dashboard');

  const renderView = () => {
    switch (currentTab) {
      case 'dashboard': return <Dashboard />;
      case 'envelopes': return <Envelopes />;
      case 'transactions': return <Transactions />;
      case 'demo': return <Demo />;
      case 'settings': return <Settings />;
      default: return <Dashboard />;
    }
  };

  return (
    <AppShell currentTab={currentTab} setCurrentTab={setCurrentTab}>
      {renderView()}
    </AppShell>
  );
}